'use client';

import { useEffect, useState } from 'react';
import { Drawer, Flex, Link as ChakraLink, Portal, useDisclosure } from '@chakra-ui/react';
import { useMediaQuery } from '@chakra-ui/react';
import NextLink from 'next/link';

import { createCookies, getCookies } from '~/app/actions';

import { ButtonCore, TypographyCore } from '../core-components';

import styles from './cookie-accept.module.css';

export const CookiesAccept = () => {
    const { open, onOpen, onClose } = useDisclosure();
    const [isOpenDesktopAccept, setOpenDesktopAccept] = useState(false);
    const [isMobilePhone, setIsMobilePhone] = useState(null);

    const [isMobile] = useMediaQuery(['(max-width: 850px)'], {
        ssr: true,
        fallback: [true],
    });
    const handleAcceptCookie = async () => {
        if (typeof window !== 'undefined') {
            await createCookies({
                name: 'cp',
                value: 'accept',
                secure: true,
                httpOnly: true,
                maxAge: 2147483647,
            });

            onClose();
            setOpenDesktopAccept(false);
        }
    };

    useEffect(() => {
        getCookies('cp').then((item) => {
            if (item) {
                onClose();
                setOpenDesktopAccept(false);
            } else {
                onOpen();
                setOpenDesktopAccept(true);
            }
        });
    }, [onClose, onOpen]);

    useEffect(() => {
        // @ts-expect-error kmpJsBridge находится в window только при открытии мобильного приложения
        if (typeof window !== 'undefined' && window.kmpJsBridge) {
            // @ts-expect-error kmpJsBridge находится в window только при открытии мобильного приложения
            window.kmpJsBridge.callNative('MobilePlatform', JSON.stringify({ message: 'Hello' }), function (data) {
                setIsMobilePhone(data);
            });
        }
    });

    if (isMobilePhone) {
        return null;
    }

    if (isMobile) {
        return (
            <Drawer.Root placement='bottom' open={open} onOpenChange={handleAcceptCookie}>
                <Portal>
                    <Drawer.Backdrop />
                    <Drawer.Positioner>
                        <Drawer.Content borderTopLeftRadius={'12px'} borderTopRightRadius={'12px'} border={'none'}>
                            <Drawer.Header />
                            <Drawer.Body>
                                <TypographyCore view='medium' size='m' className='mb-16'>
                                    Мы используем{' '}
                                    <ChakraLink
                                        as={NextLink}
                                        href={`/oferta`}
                                        className={styles['document-button']}
                                        _hover={{ textDecoration: 'none' }}
                                        display={'inline'}
                                    >
                                        cookies
                                    </ChakraLink>
                                    , чтобы сохранять ваш поиск, рекомендовать полезное и создавать другие удобства на сайте
                                </TypographyCore>
                                <ButtonCore view='accent' onClick={handleAcceptCookie} size='small'>
                                    Окей
                                </ButtonCore>
                            </Drawer.Body>
                            <Drawer.Footer />
                        </Drawer.Content>
                    </Drawer.Positioner>
                </Portal>
            </Drawer.Root>
        );
    }

    return (
        <>
            {isOpenDesktopAccept ? (
                <Flex className={styles.container}>
                    <TypographyCore view='medium' size='m'>
                        Мы используем{' '}
                        <ChakraLink
                            as={NextLink}
                            href={`/oferta`}
                            className={styles['document-button']}
                            _hover={{ textDecoration: 'none' }}
                            display={'inline'}
                        >
                            cookies
                        </ChakraLink>
                        , чтобы сохранять ваш поиск, рекомендовать полезное и создавать другие удобства на сайте
                    </TypographyCore>
                    <ButtonCore
                        view='accent'
                        onClick={handleAcceptCookie}
                        size='small'
                        style={{
                            width: '8vw',
                            maxWidth: '100px',
                            marginLeft: '8px',
                        }}
                    >
                        Окей
                    </ButtonCore>
                </Flex>
            ) : null}
        </>
    );
};
